interface IProps {
  className?: string
}

export const DndBurgerIcon = ({ className }: IProps) => (
  <svg
    id="icon"
    width={24}
    height={24}
    fill="#999999"
    className={className}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="4 20 15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20" />
    <polygon points="11 7 12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7" />
    <rect
      fill="none"
      data-name="&lt;Transparent Rectangle&gt;"
      height="32"
      id="_Transparent_Rectangle_"
      width="32"
    />
  </svg>
)
